/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_ButtonInputs */

const en_landing_cta_button = /** @type {(inputs: Landing_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get started for free`)
};

const zh_landing_cta_button = /** @type {(inputs: Landing_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费开始使用`)
};

/**
* | output |
* | --- |
* | "Get started for free" |
*
* @param {Landing_Cta_ButtonInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_cta_button = /** @type {((inputs?: Landing_Cta_ButtonInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_ButtonInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cta_button(inputs)
	return zh_landing_cta_button(inputs)
});
export { landing_cta_button as "landing.cta.button" }